import { useContext } from 'react';

import { FeaturesContext } from './features-context';
import { FeatureName } from './types';

export const useFeature = (name: FeatureName) => {
  const features = useContext(FeaturesContext);
  return features[name];
};
